import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on POLICIES
  fetchPolicy: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPolicy';

    commit(`${mutationPrefix}Pending`);

    return api.fetchPolicy(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on POLICIES
  createPolicy: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createPolicy';

    commit(`${mutationPrefix}Pending`);

    return api.createPolicy(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on POLICIES
  updatePolicy: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'updatePolicy';

    commit(`${mutationPrefix}Pending`);

    return api.updatePolicy(data)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses DELETE mutations on POLICIES (done by admin)
  deletePolicy: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deletePolicy';

    commit(`${mutationPrefix}Pending`, id);

    return api.deletePolicy(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses UPDATE mutations on POLICIES
  acceptPolicy: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'acceptPolicy';

    commit(`${mutationPrefix}Pending`);

    return api.acceptPolicy(data)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/policy/actions.js